module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bootstrap/fonts/glyphicons-halflings-regular.woff
// module id = 1194
// module chunks = 8